import React from 'react'

import { size, isEmpty } from 'lodash'

import cn from 'classnames'

import { Box, TextField, Button, Container, Typography, Collapse } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import PasswordStrength from '@scoir/components-core/dist/components/PasswordStrength'

import api from 'common/api'

import './index.scss'

class ChangePassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saved: false,
      error: false,
    }
  }

  componentDidMount() {
    document.title = 'Scoir - Change your Password'
  }

  handleUpdate(name, value) {
    this.setState({
      [name]: value,
    })
  }

  handlePasswordChange(name, value) {
    this.handleUpdate(name, value)
    this.setState({
      strength: PasswordStrength.validateStrength(value),
    })
  }

  isPasswordInvalid() {
    return !isEmpty(this.state.password) && size(this.state.password) < 8
  }

  isConfirmPasswordInvalid() {
    return !isEmpty(this.state.confirmedPassword) && this.state.password !== this.state.confirmedPassword
  }
  disableSubmit() {
    return (
      this.isPasswordInvalid() ||
      this.isConfirmPasswordInvalid() ||
      isEmpty(this.state.currentPassword) ||
      isEmpty(this.state.password) ||
      isEmpty(this.state.confirmedPassword)
    )
  }

  submit(e) {
    e.preventDefault()
    api
      .post('/api/user/password', {
        ExistingPassword: this.state.currentPassword,
        Password: {
          Pass: this.state.password,
          PassConfirm: this.state.confirmedPassword,
        },
      })
      .then(() => this.setState({ saved: true, error: false }))
      .catch(() => this.setState({ error: true }))
  }

  render() {
    return (
      <Container maxWidth="xs">
        <Box
          mt={3}
          mb={2}
        >
          <Typography
            component="h1"
            variant="h4"
          >
            Change your Password
          </Typography>
        </Box>
        <Box
          bgcolor="background.paper"
          borderRadius="borderRadius"
          p={2}
          className="route-change-password"
        >
          {this.state.saved && (
            <Box my={4}>
              <Alert
                severity="success"
                icon={false}
              >
                Your password has been changed. You can use your new password the next time you log in.
              </Alert>
            </Box>
          )}
          <Collapse in={!this.state.saved}>
            <form onSubmit={(e) => this.submit(e)}>
              <TextField
                type="password"
                name="currentPassword"
                label="Current Password"
                onChange={(e) => this.handleUpdate(e.target.name, e.target.value)}
                required
                margin="normal"
                variant="outlined"
                fullWidth
              />

              <Box
                mt={2}
                py={2}
                borderTop={1}
                borderColor="divider"
              >
                <TextField
                  type="password"
                  name="password"
                  label="New Password"
                  helperText="Enter at least 8 characters"
                  minLength="8"
                  onChange={(e) => this.handlePasswordChange(e.target.name, e.target.value)}
                  required
                  error={this.isPasswordInvalid()}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />

                <TextField
                  type="password"
                  name="confirmedPassword"
                  label="Confirm Password"
                  minLength="8"
                  onChange={(e) => this.handleUpdate(e.target.name, e.target.value)}
                  required
                  margin="normal"
                  variant="outlined"
                  error={this.isConfirmPasswordInvalid()}
                  fullWidth
                />
                <div className="strength-indicator">
                  <div
                    className={cn('strength-indicator-bar', {
                      'active low': this.state.strength === PasswordStrength.constants.WEAK,
                    })}
                  >
                    <span className="flavor-text">Weak</span>
                  </div>
                  <div
                    className={cn('strength-indicator-bar', {
                      'active medium': this.state.strength === PasswordStrength.constants.ADAQUATE,
                    })}
                  >
                    <span className="flavor-text">Moderate</span>
                  </div>
                  <div
                    className={cn('strength-indicator-bar', {
                      'active high': this.state.strength === PasswordStrength.constants.STRONG,
                    })}
                  >
                    <span className="flavor-text">Strong</span>
                  </div>
                </div>
                <Typography
                  color="textSecondary"
                  variant="body2"
                >
                  PASSWORD STRENGTH
                </Typography>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                my={2}
              >
                {this.state.error && (
                  <Box mb={2}>
                    <Alert
                      severity="error"
                      icon={false}
                    >
                      Unable to change your password, please try again later.
                    </Alert>
                  </Box>
                )}

                <Button
                  color="primary"
                  variant="contained"
                  type="submit"
                  disabled={this.disableSubmit()}
                >
                  Submit
                </Button>
              </Box>
            </form>
          </Collapse>
        </Box>
      </Container>
    )
  }
}

export default ChangePassword
